import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { event: String, googleAdsEventId: String }

  trackEvent() {
    var eventName = this.eventValue
    var googleAdsEventId = this.googleAdsEventIdValue

    if (window.rails_env === "production") {
      // Facebook tracking
      if (typeof fbq !== "undefined") {
        fbq("trackCustom", eventName)
      }

      // Microsoft UET tracking
      if (typeof window.uetq !== "undefined") {
        window.uetq.push("event", eventName, {})
      }
    } else if (window.rails_env === "development") {
      console.info(`Facebook Ads tracked: event "${eventName}"`)
      console.info(`Google Ads tracked: event ID "${googleAdsEventId}"`)
      console.info(`Microsoft Ads tracked: event "${eventName}"`)
    }

    return false
  }
}
